export const css = {
	root: '_3IT2o2PK',
	content: '_4q0DmYHJ',
	label: '_3aGyEuft',
	actions: '_3iIaoaw9',
	open: '_3G0MVvtM',
	success: '_34Ja6VIG',
	error: 'uVBQ5gx0',
	leading: 'Lhf3spYU',
	stacked: '_3-S_KzNi',
	' _key': 'afcpe-theme/dojo/snackbar'
};

export default css;
